import React, { useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import Button from '../../../common/Buttons/Button';
import ButtonIcon from '../../../common/ButtonIcon/ButtonIcon';
import VocabularyButton from '../../../common/VocabularyButton/VocabularyButton';
import CourseName from '../../CourseName/CourseName';
import { homeworkColors } from '../../schedule/constants';

import useCountdown from '../hooks/useCountdown';
import Popover from '../Popover/Popover';

import './finances-card.styles.scss';
import '../common-countdown.styles.scss';

const FinancesCard = ({ course, getAccounts, getDocuments, type }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const setHomeworkPage = () => {
    localStorage.setItem('event', JSON.stringify(course));
    localStorage.setItem('eventId', JSON.stringify(course.event_id));
    localStorage.setItem('realHomeworkId', JSON.stringify(course.homework_id));
    navigate('/homework', { state: { from: location.pathname } });
  };

  const shouldPulse = course.homework_icon_color != 4;
  const hex = homeworkColors[course.homework_icon_color];
  const pulseStyle = shouldPulse ? { '--pulse-color': hex } : {};
  const setLink = (link) => window.open(link, '_blank');

  const { compact } = useCountdown(course.cancellation_lesson_date);
  const showCountdown = Boolean(course.cancellation_lesson_date);

  const [openInfo, setOpenInfo] = useState(false);
  const infoAnchorRef = useRef(null);
  const infoText = `Заняття будуть анульовані згідно з Договором через ${compact}`;

  return (
    <div className="card-finances">
      <CourseName img={course.image} name={course.name} label={course.type} />

      {type === 'trial_courses' && (
        <div className="card-program-block">
          <div className="card-program-block__title">Матеріали</div>
          <div className="program-item__btns">
            {course.presentation_link && (
              <ButtonIcon classes='program-item__btn' icon='monitor' btnBg='white'
                iconColor='green' btnSize='lg' iconSize='md'
                onClick={() => setLink(course.presentation_link)}
              />
            )}
            {course.google_pdf_url && (
              <ButtonIcon classes='program-item__btn' icon='pdf' btnBg='white'
                iconColor='green' btnSize='lg' iconSize='md'
                onClick={() => setLink(course.google_pdf_url)}
              />
            )}
            {course.youtube_link && (
              <ButtonIcon classes='program-item__btn' icon='youtube' btnBg='white'
                iconColor='green' btnSize='lg' iconSize='md'
                onClick={() => setLink(course.youtube_link)}
              />
            )}
            {course.vocabulary_link && (
              <ButtonIcon classes='program-item__btn' icon='list' btnBg='white'
                iconColor='green' btnSize='lg' iconSize='md'
                onClick={() => setLink(course.vocabulary_link)}
              />
            )}

            <VocabularyButton classes='program-item__btn' token={course.vocabulary_token} />
            {course.is_show_homework && (
              <div className="homework-icon-wrapper">
                {course.is_show_icon_new && <div className="new-badge">new</div>}
                <ButtonIcon
                  classes={`program-item__btn ${shouldPulse ? 'pulsing-icon' : ''}`}
                  icon='book' btnBg='white'
                  iconColor={homeworkColors[course.homework_icon_color]}
                  btnSize='lg' iconSize='md'
                  onClick={() => setHomeworkPage(course)}
                  style={pulseStyle}
                />
              </div>
            )}
          </div>
        </div>
      )}

      {type !== 'trial_courses' && (
        <div className='card-finances__content'>
          <div className="card-finances-text">
            <span>Залишок занять:</span>
            <span>
              {showCountdown && (
                <span className="fin-countdown">
                  <span className="fin-countdown__time">{compact}</span>
                  <button
                    ref={infoAnchorRef}
                    type="button"
                    className="fin-info-btn"
                    onClick={() => setOpenInfo(v => !v)}
                    aria-label="Докладніше"
                    title="Докладніше"
                  >
                    i
                  </button>
                  {openInfo && (
                    <Popover
                      anchorRef={infoAnchorRef}
                      onClose={() => setOpenInfo(false)}
                    >
                      {infoText}
                    </Popover>
                  )}
                </span>
              )}
              <span className="fin-qty-mobile">{course.qty}</span>
            </span>
          </div>

          <div className="card-finances-text">
            <span>Залишок на балансі:</span>
            <span>{course.total} грн</span>
          </div>
        </div>
      )}

      <div className="card-finances__btns">
        {type === 'course'
          ? (course.status != 3 && (
            <Button buttonBg='green' loading="" onClick={() => getAccounts(course.product_id, type)}>
              Оплатити
            </Button>
          ))
          : (
            <Button buttonBg='green' loading="" onClick={() => getAccounts(course.product_id, type)}>
              Оплатити
            </Button>
          )
        }

        {type !== 'trial_courses' && (
          <Button buttonBg="transparent link" loading="" onClick={() => getDocuments(course.product_id)}>
            Детальний звіт
          </Button>
        )}
      </div>
    </div >
  );
};

FinancesCard.propTypes = {
  course: PropTypes.object.isRequired,
  getDocuments: PropTypes.func.isRequired,
  getAccounts: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export default FinancesCard;